import { ICharacter } from './character';
import { IEpisode } from './episode';
import { IExternalReference } from './external-reference';
import { IScene } from './scene';
import { ITopic } from './topic';
import { PlatformTypes} from './enums/platform-types';
import { IIpHolder } from './ip-holder';

export enum NarrativeTypes {
    book = 'book',
    film = 'film',
    series = 'series',
}

export enum RatingLabelTypes {
    TV_Y = 'TV-Y',
    TV_Y7 = 'TV-Y7',
    TV_G = 'TV-G',
    TV_PG = 'TV-PG',
    TV_14 = 'TV-14',
    TV_MA = 'TV-MA',
}


export const NarrativeAvailabiltyFilter = [
 { name :'enabled',uid:'1'},
 { name :'disabled',uid:'0'},
]

export const ContentAgeRating: Record<number, string> = {
    0: 'All (0+)',
    7: 'Older Kids (7+)',
    13: 'Teens (13+)',
    16: 'Young Adults (16+)',
    18: 'Adults (18+)',
};


export interface INarrative {
    uid: string,
    title: string,
    description: string,
    mediaType: NarrativeTypes,
    platformType: PlatformTypes,
    platforms?: string[],
    fileName?: string,
    emailImageFileName?: string,
    audioSignatureFileName?: string,
    audioCatalogFileName?: string,
    soundtrackFileName?: string,
    imageFile?: File,
    externalImageUrl?: string,
    contentUrl?: string,
    available?: boolean,
    enabledAt?: string,
    isNew?: boolean,
    minAgeRating: number,
    ratingLabel?: string,
    comingSoon?: boolean,
    status?: string,
    duration?: number,
    ipLicensed?: boolean,
    ignoreIPLicensing?: boolean,

    tasksAvailableForUserCount?: number,

    episodes?: IEpisode[],
    characters?: ICharacter[],
    scenes?: IScene[],
    topics?: ITopic[],

    endSurveyUid?: string,
    ipHolder?: IIpHolder,

    externalReferences?: IExternalReference[],

    selected?: boolean,
}
